/**
 * SiteHeader — the sticky top chrome: the PSPulse wordmark (♥ + name), the
 * theme switcher, and a link to the API docs. Persists across every screen.
 *
 * The wordmark is a SINGLE client-side router link back to the overview: the
 * crafted HeartMark leads the "PSPulse" lockup, is `aria-hidden` (no duplicate
 * SR announcement, no second tab stop), and does one biological lub-dub on
 * hover/focus (CSS — NOT the infinite `.heart-mark` loop).
 *
 * The right cluster is `[theme switcher] · divider · API docs`; it's laid out
 * so a future language picker (#110) slots in as one more sibling with no
 * restructuring.
 */

import { Link } from "react-router-dom";
import { HeartMark } from "./HeartMark";
import { ThemeSwitcher } from "./ThemeSwitcher";

export function SiteHeader() {
  return (
    <header className="site-header">
      <Link className="wordmark" to="/" aria-label="PSPulse — vai alla home">
        {/* One-shot hover/focus beat is driven by CSS on `.wordmark__heart`;
            this must NOT carry `.heart-mark` (that class loops forever). */}
        <HeartMark size={21} className="wordmark__heart" />
        <span className="wordmark__text">
          PS<strong>Pulse</strong>
        </span>
      </Link>
      <nav className="header-nav" aria-label="Navigazione principale">
        <ThemeSwitcher />
        <span className="header-nav__divider" aria-hidden="true" />
        <a
          className="header-nav__link"
          href="/api/scalar/v1"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="API docs"
        >
          {/* Visible text collapses to "API" below ~40rem; the accessible name
              stays "API docs" via aria-label regardless of the breakpoint. */}
          API<span className="header-nav__docs">&nbsp;docs</span>
        </a>
      </nav>
    </header>
  );
}
